import { createSelector } from 'reselect';

export const getServicesData = (state) => state.services;
export const getServicesListingData = (state) => state.services.listing;

export const isLoadingServicesList = (state) => getServicesListingData(state).isLoading;

export const areServicesListLoaded = (state) => getServicesListingData(state).areServicesLoaded;

export const getServicesList = (state) => getServicesListingData(state).servicesList;

export const getServiceDetails = (state, { serviceId }) =>
    getServicesList(state).reduce((acc, cur) => ({
        ...acc, 
        [cur.id]: cur
    }), {})[serviceId];


// export const getPageSeoMetadataWithStatus = createSelector(
//     getPageSEOMetadata,
//     getLoadPageSEOMetadataStatus,
//     (data = {}, status = {}) => ({ ...data, ...status }),
// );